import { JustpayRevenueEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-revenue-endpoint-service"

export class JustpayRevenueService {
    constructor () {
        this.justpayRevenueEndpointService = new JustpayRevenueEndpointService()
    }

    async changeRevenue (request) {
        await this.justpayRevenueEndpointService.changeRevenue(request)
    }

    async conductRevenue (request) {
        await this.justpayRevenueEndpointService.conductRevenue(request)
    }

    async createRevenue (request) {
        await this.justpayRevenueEndpointService.createRevenue(request)
    }

    async getRevenue (taskId) {
        const response = await this.justpayRevenueEndpointService.getRevenues({ id: taskId })
        response.data = response.data.length > 0 ? response.data[0] : {}
        return response
    }

    async getRevenues (arg) {
        return this.justpayRevenueEndpointService.getRevenues(arg)
    }
}
